module.exports = __webpack_public_path__ + "static/media/main-logo.a4f8a8c2.svg";